import { render, staticRenderFns } from "./ClientEventProcedureItemV2ProcedureItem.vue?vue&type=template&id=2e94e8b5&scoped=true"
import script from "./ClientEventProcedureItemV2ProcedureItem.vue?vue&type=script&lang=js"
export * from "./ClientEventProcedureItemV2ProcedureItem.vue?vue&type=script&lang=js"
import style0 from "./ClientEventProcedureItemV2ProcedureItem.vue?vue&type=style&index=0&id=2e94e8b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e94e8b5",
  null
  
)

export default component.exports